import styled from "styled-components";

import { BodyText, FlexBox, Heading } from "@braze/beacon-core";
import { getColor } from "@braze/beacon-styling";

export const StyledFlexBox = styled(FlexBox)`
  gap: clamp(10px, 2vw, 20px);
`;

export const ListItemLogo = styled.img`
  height: clamp(36px, 2vw, 48px);
  width: auto;
`;

export const StyledHeading = styled(Heading)`
  font-size: clamp(12px, 1.5vw, 24px);
  line-height: clamp(1.2em, 2vw, 1.3em);
  margin-bottom: 12px;
  color: ${getColor("gray", 0)};
`;

export const StyledBodyText = styled(BodyText)`
  font-size: clamp(6px, 1.2vw, 20px);
  line-height: clamp(1.3em, 1.2vw, 1em);
  color: ${getColor("gray", 0)};
  @media (max-width: 1220px) {
    display: none;
  }
`;
